<template>
  <div>
    <template v-for="step in steps">
      <template v-for="(files, i) in [ getFilesOfStage(step) ]">
        <template v-if="files.length">
          <div
            class="cooperation-page__files-stage-wrapper"
            :class="'stage-' + step"
            :key="step * (i + 1)"
          >
            <div class="cooperation-page__files-stage-title">{{step}} {{$tCooperation('step')}}:</div>

            <div class="cooperation-page__files-stage-list">
              <div v-for="file in files" class="cooperation-page__files-stage-item" :key="file.name">
                <span class="cooperation-page__files-stage-item-title" @click="download(file)">{{ file.name }}</span>

                <div class="cooperation-page__files-stage-item-details">
                  <span class="cooperation-page__files-stage-item-type">{{ file.ext }}, </span>
                  <span class="cooperation-page__files-stage-item-weight">{{ formatSize(file.size) }}</span>

                  <BaseSvg name="ico-download" @click.native="download(file)"/>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
    </template>

    <div v-if="isEmployer" class="cooperation-page__actions-wrapper">
      <button
        class="base-btn base-btn--blue"
        :class="{ '_loading': isLoading }"
        :disabled="status !== 1"
        @click="$emit('ready')"
      >
        <BasePreloader v-if="isLoading"/>
        <span class="base-btn__text">{{$tCooperation('Accept and continue to the next step')}}</span>
      </button>

      <button
        class="base-btn base-btn--outline-grey"
        :class="{ '_loading': isLoading }"
        :disabled="status === 0"
        @click="$emit('decline')"
      >
        <BasePreloader v-if="isLoading"/>
        <span class="base-btn__text">{{$tCooperation('Return')}}</span>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: [ 'files', 'steps', 'status', 'isEmployer', 'isLoading' ],

    data() {
      return {
        sizeList: [ 'b', 'Kb', 'Mb', 'Gb' ]
      };
    },

    methods: {
      getFilesOfStage(step) {
        return this.files.filter((f) => f.step === step);
      },

      formatSize(size, lvl = 0) {
        if (size >= 1024 && lvl < this.sizeList.length - 1) return this.formatSize(size / 1024, lvl + 1);
        return size.toFixed(2).replace('.00', '') + this.sizeList[ lvl ];
      },

      download(file) {
        const link = document.createElement('a');
        link.setAttribute('download', `${file.name}.${file.ext}`);
        link.setAttribute('target', '_blank');
        link.setAttribute('href', file.path);
        link.click();
        link.remove();
      }
    }
  };
</script>
